'use strict';

angular.module('TurneroApp').component('coAgendaHistorial', {
    bindings: {
        centroAtencionSeleccionado: '<',
        agendaSeleccionada: '<',
        ctrlPadre: '='
    },
    controller: [
        'agendaService',
        'utilsService',
        function ( agendaService, utilsService) {
            var ctrl = this;

            ctrl.limpiarMemoria = function () {
                ctrl.Agenda = {
                    Cuit: '',
                    Log_Cambios: '',
                    Fecha: ''
                }
            }
            ctrl.limitOptions = [10, 25, 50, 75, 100, {
                label: 'Todos',
                value: function () {
                    return ctrl.pagination.total;
                }
            }];

            ctrl.query = {
                limit: 10,
                page: 1,
                filter: ''
            };

            //Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
                total: null
            };

           ctrl.cargarGrilla = function () {
                if (ctrl.query.Id_Agenda) {
                    utilsService.swalTitle('Cargando Información', 'info')
                    agendaService.Get_Historial({
                        'filtro.Id_Agenda': ctrl.query.Id_Agenda,
                        'filtro.Nro_Pagina': ctrl.query.page,
                        'filtro.Tam_Pagina': ctrl.query.limit
                    }).$promise.then(function (resultado) {
                        ctrl.Agenda = resultado.Data;
                        ctrl.pagination.total = resultado.Paging.Reg_Totales;
                        swal.close();
                    }).catch(function (error) {
                        swal.close()
                        utilsService.errores(error);
                    })
                }
            }


            ctrl.$onChanges = function () {
            	if (ctrl.agendaSeleccionada && ctrl.ctrlPadre.agendaHistorial) {
                    ctrl.limpiarMemoria();
                    ctrl.query.Id_Agenda = ctrl.agendaSeleccionada.Id_Agenda;
                    ctrl.N_Agenda = ctrl.agendaSeleccionada.N_Agenda;
                    ctrl.query.Id_Agenda && ctrl.cargarGrilla();
                }

            };

            ctrl.volver = function () {
                ctrl.limpiarMemoria();
                ctrl.ctrlPadre.consultaAgendas(true);
            }



        }
    ],
    template: require('./agenda_Historial.html')
});



// WEBPACK FOOTER //
// ./app/components/agenda/agenda_HistorialComponent.js